export const LOGO_URL = "/logo.png";

export const DEFAULT_BANNER =
  "https://images.pexels.com/photos/8033889/pexels-photo-8033889.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const TAGLINE = "Embark on Life's Voyage";

export const GRADE_OPTIONS = [
  "Pre-K (3)",
  "Pre-K (4)",
  "Kindergarten",
  "1st Grade",
  "2nd Grade",
  "3rd Grade",
  "4th Grade",
  "5th Grade",
  "6th Grade",
  "7th Grade",
  "8th Grade",
  "9th Grade",
  "10th Grade",
  "Other",
];
